import imagesLoaded from 'imagesLoaded'
import Masonry from 'masonry-layout'
import {
  GalleryOptions
} from './imports/fancybox-options'

import scrolltofixed from 'scrolltofixed'

$(document).ready(function () {
  $('.scrolltofixed').scrollToFixed({
    marginTop: 100,
    minWidth: 975
  });
});

if ($('.grid').length > 0) {
  imagesLoaded(
    $('.grid'),
    function (instance) {
      new Masonry('.grid', {
        itemSelector: '.grid-item',
        // columnWidth: '.grid-sizer',
        gutter: 10,
        isResizeBound: true,
      });

      $('.grid-item').animate({
        opacity: 1
      });
    });
}

$('[data-fancybox]').fancybox(GalleryOptions);


// WEBPACK FOOTER //
// ./src/js/collections.js